// extracted by mini-css-extract-plugin
export default {"container":"AppointmentTable_container__NaIiY","title":"AppointmentTable_title__DMy+2","button":"AppointmentTable_button__i2-uF"};